import { SIGN_IN_SUCCESS, SIGN_OUT_SUCCESS, INIT_DATA } from './types/index';
import { getInits, setFirebaseRealTime, initializeDeliveryBDD } from '../apis/firebase';
import { getUserPermissions } from 'src/utils/admins';

export const setLoggedInUser = (shopId, isAllShops, isShopChanged = false) => async dispatch => {
  await initializeDeliveryBDD();
  const userPermissions = await getUserPermissions(shopId)
  await setFirebaseRealTime(dispatch, shopId, userPermissions, isAllShops, isShopChanged);
  const { initDatas, initializedApp } = await getInits(shopId)
  dispatch({
    type: SIGN_IN_SUCCESS,
    payload: { ...initDatas, initializedApp, isAllShops, userPermissions }
  });
};

export const intializingData = boolean => dispatch => {
  dispatch({ type: INIT_DATA, payload: boolean });
};

export const setLogOut = () => async dispatch => {
  dispatch({ type: SIGN_OUT_SUCCESS });
};
